import { Injectable } from '@angular/core';
import { ContentfulClientApi, createClient } from 'contentful';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ContentfulClientService {
  constructor() {}

  public createClient(): ContentfulClientApi {
    return createClient({
      environment: environment.contentful.environment,
      space: environment.contentful.spaceId,
      accessToken: environment.contentful.api_string,
    });
  }
}
